import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import IconExperiences from '@/components/assets/icon_control_bar_experiences.svg';
import IconGamepad from '@/components/assets/icon_control_bar_gamepad.svg';
import ViverseButton from '@/components/ViverseButton';
import { cn } from '@/lib/utils';
type ControlBarMoreButtonProps = ComponentProps<typeof ViverseButton> & {
  contentKind: 'experiences' | 'games';
  showIcon?: boolean;
};
export default function ControlBarMoreButton(t0) {
  const $ = _c(18);
  let children;
  let className;
  let contentKind;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      contentKind,
      children,
      showIcon: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = contentKind;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    contentKind = $[3];
    props = $[4];
    t1 = $[5];
  }
  const showIcon = t1 === undefined ? true : t1;
  const Icon = contentKind === "games" ? IconGamepad : IconExperiences;
  let t2;
  if ($[6] !== className) {
    t2 = cn("bg-control-bar-more border-control-bar-accent flex h-[30px] w-[61px] shrink-0 items-center justify-center gap-1 rounded-full border-2 px-1.5 py-1 text-[11px] leading-[18px] font-medium tracking-[0.15px] text-white backdrop-blur-[20px] @[753px]:h-[34px] @[753px]:w-auto @[753px]:gap-2 @[753px]:px-5.5 @[753px]:py-1.5 @[753px]:text-[12.5px]", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children) {
    t3 = <span className="inline-flex items-center justify-center">{children}</span>;
    $[8] = children;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== Icon || $[11] !== showIcon) {
    t4 = showIcon && <span className={cn("inline-flex size-3.5 shrink-0 items-center justify-center @[753px]:size-5")}><Icon className="block size-full" viewBox="0 0 20 20" aria-hidden="true" /></span>;
    $[10] = Icon;
    $[11] = showIcon;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== props || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <ViverseButton variant="custom" size="custom" className={t2} {...props}>{t3}{t4}</ViverseButton>;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}